import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import s from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: t = 16, useVw: n, useRem: c, color: l, withColor: o, removeClassName: e, disableSSR: m, style: r, ...p }) => {
  const x = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(s, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-yunsuanli", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-äºç®å"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: o ? i(l, 0, "#262933") : "#262933",
        datafollowfill: o ? i(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M8.426 13.01c.68-3.501 3.526-6.11 6.916-6.11 2.805 0 5.364 1.88 6.451 4.56.26.638.814 1.088 1.451 1.246.372.093.732.229 1.075.403 1.89.963 3.281 3.128 3.281 5.748 0 1.36-.504 2.957-1.426 4.202-.914 1.233-2.173 2.041-3.688 2.041H18a.9.9 0 1 0 0 1.8h4.486c2.23 0 3.977-1.208 5.134-2.77 1.149-1.55 1.78-3.522 1.78-5.273 0-3.249-1.73-6.06-4.264-7.352a6.857 6.857 0 0 0-1.457-.545.313.313 0 0 1-.218-.177C22.13 7.502 18.961 5.1 15.342 5.1c-4.375 0-7.864 3.346-8.683 7.566a.315.315 0 0 1-.171.209C4.213 14.055 2.6 16.63 2.6 19.572c0 3.997 2.966 7.328 6.821 7.328h.989a3.9 3.9 0 0 0 3.423-2.031l3.457-6.332a.9.9 0 1 0-1.58-.863l-3.457 6.332A2.1 2.1 0 0 1 10.41 25.1h-.99c-2.724 0-5.02-2.383-5.02-5.529 0-2.299 1.263-4.242 2.915-5.098a2.113 2.113 0 0 0 1.11-1.464Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M13.818 16.291c2.41-1.96 5.965.093 5.472 3.16a.9.9 0 1 0 1.777.285c.756-4.7-4.693-7.846-8.385-4.84a.9.9 0 1 0 1.136 1.395Z"
        }
      )
    )
  )));
}, g = f;
export {
  g as default
};
